// ★del start matsunaga AWSのパッケージは使用しない
//import { fetchAuthSession } from "aws-amplify/auth";
// ★del end
import { StorageHelper } from "../helpers/storage-helper";

export abstract class ApiClientBase {
  protected async getHeaders() {
    return {
      // Authorization: `Bearer ${await this.getIdToken()}`,
      Authorization: `Bearer ${StorageHelper.getToken()}`
    };
  }

  protected async getIdToken() {
    // ★upd start matsunaga AWSのパッケージは使用しない
    // const session = await fetchAuthSession();
    // return session.tokens?.idToken?.toString();
    return "test"; // 適当な文字列を返す
    // ★upd end
  }
}
